<template>
    <div class="table-pagination">
        <div class="row">
            <div class="col-md-7">
                <div class="record-shown">
                    <b-form-group
                        :class="
                            selectPaginationDisable == true ? 'disable' : ''
                        "
                    >
                        <b-form-select
                            id="input-3"
                            v-model="record"
                            class="form-control"
                            :options="showRecords"
                            @change="paginationChanged($event)"
                        ></b-form-select>
                    </b-form-group>
                    <p>{{ composePaginationLabel }}</p>
                </div>
            </div>
            <div class="col-md-5">
                <div class="next-previous-pagination">
                    <b-button
                        type="submit"
                        :class="disbalePrevious ? 'disable' : ''"
                        variant="primary"
                        @click.prevent="buttonClicked('previous')"
                        >PREVIOUS</b-button
                    >
                    <b-button
                        type="submit"
                        variant="primary"
                        :class="disableNext ? 'disable' : ''"
                        @click.prevent="buttonClicked('next')"
                        >NEXT</b-button
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        pagination: {
            type: Object,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            defaultsShowRecords: [
                { text: 'Show 10 records', value: 10 },
                { text: 'Show 20 records', value: 20 },
                { text: 'Show 50 records', value: 50 },
                { text: 'Show 100 records', value: 100 },
            ],
            record: 10,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        composePaginationLabel() {
            if (this.pagination) {
                if (this.pagination.totalRecords == 0) {
                    return 'No records found'
                }
                const fromShowing = this.pagination.current
                    ? (this.pagination.current - 1) * this.record + 1
                    : ' - '

                const toShowing = this.pagination.current
                    ? this.pagination.current * this.record -
                      this.record +
                      this.pagination.totalRecords
                    : ' - '

                return (
                    'Showing ' +
                    fromShowing +
                    ' to ' +
                    toShowing +
                    ' of ' +
                    (this.pagination.total ? this.pagination.total : '-') +
                    ' records'
                )
            }
            return 'Showing ' + 0 + ' to ' + 0 + ' of ' + 0 + ' records'
        },
        disbalePrevious() {
            if (this.pagination) {
                if (!this.pagination.totalRecords) {
                    return true
                }
                return this.pagination.first == this.pagination.current
            }
            return true
        },
        disableNext() {
            if (this.pagination) {
                if (this.pagination.totalRecords < this.record) {
                    return true
                }
                if (!this.pagination.totalRecords) {
                    return true
                }
                if (!this.pagination.last) {
                    return true
                }
                return this.pagination.last == this.pagination.current
            }

            return true
        },
        selectPaginationDisable() {
            if (this.pagination) {
                // if (this.pagination.totalRecords < this.record) {
                //     return true
                // }
                if (!this.pagination.totalRecords) {
                    return true
                }
                if (this.pagination.total < 10) {
                    return true
                }
            }
            return false
        },
        showRecords() {
            let self = this
            if (self.pagination) {
                self.record = self.pagination.perPage
                if (self.pagination.total > 10 && self.pagination.total < 20) {
                    return [
                        { text: 'Show 10 records', value: 10 },
                        { text: 'Show 20 records', value: 20 },
                    ]
                }
                if (self.pagination.total > 20 && self.pagination.total < 100) {
                    return self.defaultsShowRecords
                }
            }
            return self.defaultsShowRecords
        },
    }, // End of Component > methods

    watch: {
        record(val) {
            return val
        },
    },

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        if (this.pagination) {
            this.record = this.pagination.perPage
        }
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        buttonClicked(type) {
            this.$emit('button-clicked-' + type)
        },
        paginationChanged(val) {
            this.$emit('pagination-changed', val)
        },
    }, // End of Component > mounted
} // End of export default
</script>
